import * as CONSTANTS from "../common/utils/data_validations"


import {
  getCurrentBrandFromLocalStorage,
  responseErrorChecker,
} from "./sf_utils"
import { sf_fetch } from "./sf_fetch"
import { AppConfiguration } from "config"
import _ from "lodash"
import { NGINX_MAX_SIZE } from "./sf_constants"
import { requestTooLargeError } from "./errors"
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert"

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user")
  if (user) return JSON.parse(user)
  return null
}
// is user is logged in
const isUserAuthenticated = () => getLoggedInUser() !== null

// Register Method
const postJwtRegister = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })

  // Check for response status first
  const { status } = response
  if (status === 500) {
    throw "Internal Server Error"
  }

  let responseText = await response.text()

  let message = ""
  if (typeof JSON.parse(responseText).errors !== "undefined") {
    if (typeof JSON.parse(responseText).errors.detail !== "undefined") {
      message = Object.keys(JSON.parse(responseText).errors.detail)[0]
      message = `${message} ${JSON.parse(responseText).errors.detail[
        message
      ].join(",")}`
      throw message
    } else if (
      typeof JSON.parse(responseText).errors.detail_unparsed !== "undefined"
    ) {
      message = Object.keys(JSON.parse(responseText).errors.detail_unparsed)[0]
      throw (
        JSON.parse(responseText).errors.detail_unparsed[message] ||
        "Please check card details"
      )
    } else if (typeof JSON.parse(responseText).errors.title !== "undefined") {
      message = JSON.parse(responseText).errors.title
      throw message || "Please check card details"
    } else if (typeof JSON.parse(responseText).errors.code !== "undefined") {
      throw CONSTANTS.errorMessages[JSON.parse(responseText).errors.code]
    }
  }

  // Handle success
  return responseText
}

// Login Method
// const postJwtLogin = data => post(url.POST_JWT_LOGIN, data)
const postJwtLogin = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify({ user: data }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data?.token || "",
    },
  })
  let responseJson = null
  try {
    responseJson = await response.json()
  } catch (e) { }

  let message = ""

  switch (response.status) {
    case 500:
      message = "Internal Server Error. Please try again later"
      break
    case 400:
      message = "Account already exist, please login"
      break
    case 401:
      message = responseJson?.errors?.title || "Invalid credentials"
      break
    case 403:
      message = "User account inactive, please contact your admin"
      break
    case 404:
      message = responseJson?.errors?.title || "Invalid credentials"
      break
    case 422:
      message = responseJson?.errors?.title
      break
    default:
      message = "Sorry, we are unable to resolve this. Please try again later"
  }
  if (response.status !== 200) {
    throw message
  }
  const token = response.headers.get("Authorization")
  return { data: { ...responseJson.data, token } }
}

const postJwtAdminLogin = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data?.token || "",
      "is-master": data?.is_master || "",
    },
  })

  let responseJson = null
  try {
    responseJson = await response.json()
  } catch (e) { }

  let message = ""

  switch (response.status) {
    case 500:
      message = "Internal Server Error. Please try again later"
      break
    case 400:
      message = "Account already exist, please login"
      break
    case 401:
      message = responseJson?.errors?.title || "Invalid credentials"
      break
    case 403:
      message = "User account inactive, please contact your admin"
      break
    case 404:
      message = responseJson?.errors?.title || "Invalid credentials"
      break
    case 422:
      message = responseJson?.errors?.title
      break
    default:
      message = "Sorry, we are unable to resolve this. Please try again later"
  }
  if (response.status !== 200) {
    throw message
  }
  const token = response.headers.get("Authorization")
  return { data: { ...responseJson.data, token } }
}

const getCurrentUser = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "GET",
    headers: {
      Authorization: data.token,
    },
  })

  const responseText = await responseErrorChecker(response)
  // Handle success
  return JSON.parse(responseText).data
}

const fetchAccount = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "GET",
    headers: {
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })

  const responseText = await responseErrorChecker(response)
  // Handle success
  return JSON.parse(responseText).data
}

const postJwtForgetPwd = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: "",
    },
  })
  let message = ""

  switch (response.status) {
    case 500:
      message = "Internal Server Error. Please try again later"
      break
    case 400:
      message = "Account already exist, please login"
      break
    case 401:
      message = "Invalid credentials"
      break
    case 404:
      message = "Please check your email"
      break
    default:
      message = "Sorry, we are unable to resolve this. Please try again later"
  }
  if (response.status !== 200) {
    throw message
  }
  const token = response.headers.get("Authorization")
  const responseText = await response.text()
  return {
    user: {
      username: JSON.parse(responseText).first_name,
      email: JSON.parse(responseText).email,
      token,
      id: JSON.parse(responseText).id,
    },
  }
}

// postResetPwd
const postJwtResetPwd = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })
  const responseText = await responseErrorChecker(response)
  return JSON.parse(responseText).data
}

const postJwtUpdatePwd = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })
  const responseText = await responseErrorChecker(response)
  // Handle success
  return JSON.parse(responseText).data
}

// get account users
export const getUsers = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })
  if (response.status === 500) {
    throw "Internal Server Error"
  }

  const responseText = await response.text()
  let message = ""
  if (typeof JSON.parse(responseText).errors !== "undefined") {
    if (typeof JSON.parse(responseText).errors.detail !== "undefined") {
      message = Object.keys(JSON.parse(responseText).errors.detail)[0]
      message = `${message} ${JSON.parse(responseText).errors.detail[
        message
      ].join(",")}`
      throw message
    } else if (typeof JSON.parse(responseText).errors.code !== "undefined") {
      throw CONSTANTS.errorMessages[JSON.parse(responseText).errors.code]
    }
  }
  return JSON.parse(responseText)
}

// add user
export const addNewUser = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify(data.user),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })

  // Check for response status first
  const { status } = response
  if (status === 500) {
    throw "Internal Server Error"
  }

  const responseText = await response.text()

  let message = ""
  if (typeof JSON.parse(responseText).errors !== "undefined") {
    if (typeof JSON.parse(responseText).errors.detail !== "undefined") {
      message = Object.keys(JSON.parse(responseText).errors.detail)[0]
      message = `${message} ${JSON.parse(responseText).errors.detail[
        message
      ].join(",")}`
      throw message
    } else if (typeof JSON.parse(responseText).errors.code !== "undefined") {
      throw CONSTANTS.errorMessages[JSON.parse(responseText).errors.code]
    }
  }

  // Handle success
  return JSON.parse(responseText).data
}

// update user
export const updateUser = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "PUT",
    body: JSON.stringify({
      membership: {
        user: {
          first_name: data.user.first_name,
          last_name: data.user.last_name,
          email: data.user.email,
        },
        role_id: data.user.role_id,
      },
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })

  const { status } = response
  if (status === 500) {
    throw "Internal Server Error"
  }

  const responseText = await response.text()

  let message = ""
  if (typeof JSON.parse(responseText).errors !== "undefined") {
    if (typeof JSON.parse(responseText).errors.detail !== "undefined") {
      message = Object.keys(JSON.parse(responseText).errors.detail)[0]
      message = `${message} ${JSON.parse(responseText).errors.detail[
        message
      ].join(",")}`
      throw message
    } else if (typeof JSON.parse(responseText).errors.code !== "undefined") {
      throw CONSTANTS.errorMessages[JSON.parse(responseText).errors.code]
    }
  }

  // Handle success
  return JSON.parse(responseText).data
}

// delete user
export const deleteUser = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "DELETE",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })

  // Check for response status first
  const { status } = response
  if (status === 500) {
    throw "Internal Server Error"
  }

  const responseText = await response.text()

  let message = ""
  if (typeof JSON.parse(responseText).errors !== "undefined") {
    if (typeof JSON.parse(responseText).errors.detail !== "undefined") {
      message = Object.keys(JSON.parse(responseText).errors.detail)[0]
      message = `${message} ${JSON.parse(responseText).errors.detail[
        message
      ].join(",")}`
      throw message
    } else if (typeof JSON.parse(responseText).errors.code !== "undefined") {
      throw CONSTANTS.errorMessages[JSON.parse(responseText).errors.code]
    }
  }

  // Handle success
  return JSON.parse(responseText).data
}

export const deleteRole = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "DELETE",
    body: JSON.stringify({ replacement_role_id: data.replacement_role_id }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })

  // Check for response status first
  const { status } = response
  if (status === 500) {
    throw "Internal Server Error"
  }

  const responseText = await responseErrorChecker(response)
  // Handle success
  return JSON.parse(responseText).data
}

export const createAssignment = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify({
      user_id: data.user_id,
      role_id: data.role_id,
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })

  // Check for response status first
  const { status } = response
  if (status === 500) {
    throw "Internal Server Error"
  }

  const responseText = await responseErrorChecker(response)
  // Handle success
  return JSON.parse(responseText).data
}

// postCreateCampaign
const postCreateCampaign = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify(data.campaign),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
      "brand-id": data?.show_rtb_brand_ui_changes ? data?.brand_id : getCurrentBrandFromLocalStorage()?.id,
    },
  })
  let message = ""

  switch (response.status) {
    case 500:
      message = "Internal Server Error. Please try again later"
      break
    case 400:
      message = "Account already exist, please login"
      break
    case 401:
      message = "Invalid credentials"
      break
    case 404:
      message = "Page not found"
      break
    default:
      message = "Sorry, we are unable to resolve this. Please try again later"
  }
  if (response.status !== 200) {
    alert("Unable to create a campaign")
    throw message
  }
  const token = response.headers.get("Authorization")
  const responseText = await response.text()
  return JSON.parse(responseText).data
}

const postDuplicateCampaign = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify({ campaign_id: data.campaign.id }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
      "brand-id": getCurrentBrandFromLocalStorage()?.id,
    },
  })
  const responseText = await responseErrorChecker(response)
  // Handle success
  return JSON.parse(responseText).data
}

// postCreateAdgroup
const postCreateAdgroup = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify(data.adgroup),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
      "brand-id": getCurrentBrandFromLocalStorage()?.id,
    },
  })
  let message = ""

  switch (response.status) {
    case 500:
      message = "Internal Server Error. Please try again later"
      break
    case 400:
      message = "Account already exist, please login"
      break
    case 401:
      message = "Invalid credentials"
      break
    case 404:
      message = "Page not found"
      break
    default:
      message = "Sorry, we are unable to resolve this. Please try again later"
  }
  if (response.status !== 200) {
    alert("Unable to create an adgroup")
    throw message
  }
  const responseText = await response.text()
  return JSON.parse(responseText).data
}

// putModifyCampaign
const putModifyCampaign = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "PUT",
    body: JSON.stringify(data.campaign),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
      'brand-id': getCurrentBrandFromLocalStorage()?.id
    },
  })
  let message = ""

  switch (response.status) {
    case 500:
      message = "Internal Server Error. Please try again later"
      break
    case 400:
      message = "Account already exist, please login"
      break
    case 401:
      message = "Invalid credentials"
      break
    case 404:
      message = "Page not found"
      break
    case 422:
      message = "We are unable to process your request."
      break
    default:
      message = "Sorry, we are unable to resolve this. Please try again later"
  }

  if (response.status === 422) {
    ToastAlert.fire({
      icon: ToastAlertIconType.ERROR,
      title: message,
      text: "Please check your inputs and try again."
    })
    throw message;
  } else if (response.status !== 200) {
    alert("Unable to modify a campaign")
    throw message
  }
  const responseText = await response.text()
  return JSON.parse(responseText).data
}

// deleteCampaign_api
const deleteCampaign_api = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
      "brand-id": getCurrentBrandFromLocalStorage()?.id,
    },
  })
  let message = ""

  switch (response.status) {
    case 500:
      message = "Internal Server Error. Please try again later"
      break
    case 400:
      message = "Account already exist, please login"
      break
    case 401:
      message = "Invalid credentials"
      break
    case 404:
      message = "Page not found"
      break
    default:
      message = "Sorry, we are unable to resolve this. Please try again later"
  }

  if (response.status !== 200) {
    alert("Unable to delete the campaign")
    throw message
  }
  const token = response.headers.get("Authorization")
  const responseText = await response.text()
  return JSON.parse(responseText).data
}

// deleteCampaign_ad
const deleteCampaign_Ad = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "DELETE",
    body: JSON.stringify(data.campaign_id),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })
  let message = ""

  switch (response.status) {
    case 500:
      message = "Internal Server Error. Please try again later"
      break
    case 400:
      message = "Account already exist, please login"
      break
    case 401:
      message = "Invalid credentials"
      break
    case 404:
      message = "Page not found"
      break
    default:
      message = "Sorry, we are unable to resolve this. Please try again later"
  }

  if (response.status !== 200) {
    alert("Unable to delete the Campaign Ad")
    throw message
  }
  const token = response.headers.get("Authorization")
  const responseText = await response.text()
  return JSON.parse(responseText).data
}

// postCreateRole
const postCreateRole = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify(data.role),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })
  let message = ""

  switch (response.status) {
    case 500:
      message = "Internal Server Error. Please try again later"
      break
    case 400:
      message = "Account already exist, please login"
      break
    case 401:
      message = "Invalid credentials"
      break
    case 404:
      message = "Page not found"
      break
    default:
      message = "Sorry, we are unable to resolve this. Please try again later"
  }

  if (response.status !== 200) {
    alert("Unable to create a role")
    throw message
  }
  const token = response.headers.get("Authorization")
  const responseText = await response.text()
  return JSON.parse(responseText)
}

const putModifyRole = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "PUT",
    body: JSON.stringify(data.role),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })

  const responseText = await responseErrorChecker(response)
  // Handle success
  return JSON.parse(responseText).data
}

// getRoles
const getRoles = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })
  let message = ""
  const responseText = await response.text()

  if (typeof JSON.parse(responseText).errors !== "undefined") {
    if (typeof JSON.parse(responseText).errors.detail !== "undefined") {
      message = Object.keys(JSON.parse(responseText).errors.detail)[0]
      message = `${message} ${JSON.parse(responseText).errors.detail[
        message
      ].join(",")}`
      throw message
    } else if (typeof JSON.parse(responseText).errors.code !== "undefined") {
      throw CONSTANTS.errorMessages[JSON.parse(responseText).errors.code]
    }
  }
  const token = response.headers.get("Authorization")
  return JSON.parse(responseText)
}

// getCampaigns
const getCampaigns = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
      "brand-id": getCurrentBrandFromLocalStorage().id,
    },
  })
  let message = ""

  switch (response.status) {
    case 500:
      message = "Internal Server Error. Please try again later"
      break
    case 400:
      message = "Account already exist, please login"
      break
    case 401:
      message = "Invalid credentials"
      break
    case 404:
      message = "Page not found"
      break
    case 403:
      message = "You are not authorized to use this page"
      break
    default:
      message = "Sorry, we are unable to resolve this. Please try again later"
  }

  if (response.status !== 200) {
    // alert("Unable to fetch campaigns")
    throw message
  }
  const token = response.headers.get("Authorization")
  const responseText = await response.text()
  return JSON.parse(responseText)
}

// modifyAdgroup
const putModifyAdgroup = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "PUT",
    body: JSON.stringify(data.adgroup),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })
  let message = ""

  switch (response.status) {
    case 500:
      message = "Internal Server Error. Please try again later"
      break
    case 400:
      message = "Account already exist, please login"
      break
    case 401:
      message = "Invalid credentials"
      break
    case 404:
      message = "Page not found"
      break
    default:
      message = "Sorry, we are unable to resolve this. Please try again later"
  }
  if (response.status !== 200) {
    // alert("Unable to modify the adgroup")
    throw message
  }
  const responseText = await response.text()
  return JSON.parse(responseText)
}

/// ADS ////

// fetchAds
const fetchAds = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
      "brand-id": getCurrentBrandFromLocalStorage()?.id,
    },
  })
  let message = ""
  const responseText = await response.text()

  if (typeof JSON.parse(responseText).errors !== "undefined") {
    if (typeof JSON.parse(responseText).errors.detail !== "undefined") {
      message = Object.keys(JSON.parse(responseText).errors.detail)[0]
      message = `${message} ${JSON.parse(responseText).errors.detail[
        message
      ].join(",")}`
      throw message
    } else if (typeof JSON.parse(responseText).errors.code !== "undefined") {
      throw CONSTANTS.errorMessages[JSON.parse(responseText).errors.code]
    }
  }
  const token = response.headers.get("Authorization")
  return JSON.parse(responseText)
}

// Create Ad
const postCreateAd = async (url, data) => {
  const formData = new FormData()
  for (const formKey in data.payload.ad) {
    formData.append(formKey, data.payload.ad[formKey])
  }
  // TODO- REMOVE THIS-
  formData.append("start_date", new Date())
  formData.append("end_date", new Date())
  //
  const response = await sf_fetch(url, {
    method: "POST",
    body: formData,
    headers: {
      Authorization: data.token,
      "account-id": data.account_id,
      "brand-id": data?.payload?.ad?.rtbCreativePayload?.show_rtb_brand_ui_changes ? data?.payload?.ad?.rtbCreativePayload?.brand_id : getCurrentBrandFromLocalStorage()?.id,
    },
  })
  let message = ""
  const responseText = await response.text()

  if (typeof JSON.parse(responseText).errors !== "undefined") {
    if (typeof JSON.parse(responseText).errors.detail !== "undefined") {
      message = Object.keys(JSON.parse(responseText).errors.detail)[0]
      message = `${message} ${JSON.parse(responseText).errors.detail[
        message
      ].join(",")}`
      throw message
    } else if (typeof JSON.parse(responseText).errors.code !== "undefined") {
      throw CONSTANTS.errorMessages[JSON.parse(responseText).errors.code]
    }
  }
  const token = response.headers.get("Authorization")
  return JSON.parse(responseText)
}

// FILE UPLOAD
/**
 * 
 * @param {*} url 
 * @param {*} payload 
 * @param {*} headers 
 * @param {*} key 
 * @param {*} token 
 * @returns 
 */
const postWithFileUploader = async (url, payload) => {
  const formData = new FormData();
  for (const formKey in payload.body) {
    formData.append(formKey, payload.body[formKey])
  }

  const response = await sf_fetch(url, {
    method: "POST",
    body: formData,
    headers: payload.headers,
  })
  let message = ""
  const responseText = await response.text()

  if (typeof JSON.parse(responseText).errors !== "undefined") {
    if (typeof JSON.parse(responseText).errors.detail !== "undefined") {
      message = Object.keys(JSON.parse(responseText).errors.detail)[0]
      message = `${message} ${JSON.parse(responseText).errors.detail[
        message
      ].join(",")}`
      throw message
    } else if (typeof JSON.parse(responseText).errors.code !== "undefined") {
      throw CONSTANTS.errorMessages[JSON.parse(responseText).errors.code]
    }
  }
  const token = response.headers.get("Authorization")
  return JSON.parse(responseText)
}

// Modify Ad
const putModifyAd = async (url, data) => {
  const formData = new FormData()
  for (const formKey in data.payload.ad) {
    formData.append(formKey, data.payload.ad[formKey])
  }
  const response = await sf_fetch(url, {
    method: "PUT",
    body: formData,
    headers: {
      // "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })
  let message = ""
  const responseText = await response.text()

  if (typeof JSON.parse(responseText).errors !== "undefined") {
    if (typeof JSON.parse(responseText).errors.detail !== "undefined") {
      message = Object.keys(JSON.parse(responseText).errors.detail)[0]
      message = `${message} ${JSON.parse(responseText).errors.detail[
        message
      ].join(",")}`
      throw message
    } else if (typeof JSON.parse(responseText).errors.code !== "undefined") {
      throw CONSTANTS.errorMessages[JSON.parse(responseText).errors.code]
    }
  }
  const token = response.headers.get("Authorization")
  return JSON.parse(responseText)
}

// duplicate Ad
const postDuplicateAd = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify(data.ad),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
      "brand-id": getCurrentBrandFromLocalStorage()?.id,
    },
  })
  let message = ""
  const responseText = await response.text()

  if (typeof JSON.parse(responseText).errors !== "undefined") {
    if (typeof JSON.parse(responseText).errors.detail !== "undefined") {
      message = Object.keys(JSON.parse(responseText).errors.detail)[0]
      message = `${message} ${JSON.parse(responseText).errors.detail[
        message
      ].join(",")}`
      throw message
    } else if (typeof JSON.parse(responseText).errors.code !== "undefined") {
      throw CONSTANTS.errorMessages[JSON.parse(responseText).errors.code]
    }
  }
  const token = response.headers.get("Authorization")
  return JSON.parse(responseText)
}

// deleteCreative Ad
const deleteCreativeAd = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })
  let message = ""

  switch (response.status) {
    case 500:
      message = "Internal Server Error. Please try again later"
      break
    case 400:
      message = "Account already exist, please login"
      break
    case 401:
      message = "Invalid credentials"
      break
    case 404:
      message = "Page not found"
      break
    default:
      message = "Sorry, we are unable to resolve this. Please try again later"
  }
  if (response.status !== 200) {
    alert("Unable to delete the campaign")
    throw message
  }
  const token = response.headers.get("Authorization")
  const responseText = await response.text()
  return JSON.parse(responseText).data
}

// postCreateAdgrouptracking
const postCreateAdgrouptracking = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify(data.adgroup),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })
  let message = ""

  switch (response.status) {
    case 500:
      message = "Sorry! something went wrong. Please try again later"
      break
    default:
      message = "Sorry, we are unable to resolve this. Please try again later"
  }
  if (response.status !== 200) {
    alert("Unable to create an adgroup tracking")
    throw message
  }
  const responseText = await response.text()
  return JSON.parse(responseText).data
}

// deleteAdgroup_api
const deleteAdgroup_api = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })

  const responseText = await responseErrorChecker(response)
  // Handle success
  return JSON.parse(responseText).data
}

// getBrands
const getBrands = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })

  const responseText = await responseErrorChecker(response)
  // Handle success
  return JSON.parse(responseText).data
}

const postCreateConversions = async (url, data) => {
  const formData = new FormData()
  for (const formKey in data.payload) {
    formData.append(formKey, data.payload[formKey])
  }
  const response = await sf_fetch(url, {
    method: "POST",
    body: formData,
    headers: { ...data?.headers },
  })
  let message = ""
  const responseText = await response.text()

  if (typeof JSON.parse(responseText).errors !== "undefined") {
    if (typeof JSON.parse(responseText).errors.detail !== "undefined") {
      message = Object.keys(JSON.parse(responseText).errors.detail)[0]
      message = `${message} ${JSON.parse(responseText).errors.detail[
        message
      ].join(",")}`
      throw message
    } else if (typeof JSON.parse(responseText).errors.code !== "undefined") {
      throw CONSTANTS.errorMessages[JSON.parse(responseText).errors.code]
    }
  }
  const token = response.headers.get("Authorization")
  return JSON.parse(responseText).data
}

const getPresignedUrl = async (url, data) => {
  const { file, ...noFileData } = data.payload
  const urlResponse = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify({ file_name: file.name, content_type: file.type }),
    headers: { ...data?.headers }
  })
  const urlResponseText = await responseErrorChecker(urlResponse)
  const preSignedUrl = JSON.parse(urlResponseText).data

  data.payload['conversion'] = JSON.parse(data.payload['conversion'])
  const json_string = JSON.stringify({ ...noFileData, file_name: file?.name, key: preSignedUrl.key });
  const req_size = new Blob([json_string]).size;
  if (req_size >= NGINX_MAX_SIZE) {
    throw requestTooLargeError('Request size too large');
  }

  const response = await sf_fetch(`${AppConfiguration.BACKEND_URL}/api/v1/conversions_bulk_direct`, {
    method: "POST",
    body: json_string,
    headers: { ...data?.headers },
  })
  const responseText = await responseErrorChecker(response)
  const responseData = JSON.parse(responseText).data
  return { urlData: preSignedUrl, logData: responseData }
}

const postFileToPresignedUrl = async (url, data) => {
  const file = data.payload?.file
  const s3Response = await sf_fetch(`${data.payload.signed_url}`, {
    method: "PUT",
    body: file,
    headers: {
      'Content-Type': file.type,
      'Content-Disposition': `attachment; filename=${file.name}`,
    },
  })
  if (s3Response.ok) {
    const response = await sf_fetch(url, {
      method: "PUT",
      body: JSON.stringify({ key: data.payload?.key, id: data?.payload?.id }),
      headers: { ...data.headers }
    })
    const responseText = await responseErrorChecker(response)
    return JSON.parse(responseText).data
  }
  else {
    throw "Sorry! file upload to S3 failed."
  }
}

const createBrand = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify(data.brand),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })

  const responseText = await responseErrorChecker(response)
  // Handle success
  return JSON.parse(responseText).data
}

const sfGenericRequest = async (url, method, data) => {
  const response = await sf_fetch(url, {
    method,
    body: JSON.stringify(data.body),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data.token,
      "account-id": data.account_id,
    },
  })

  const responseText = await responseErrorChecker(response)
  // Handle success
  return JSON.parse(responseText).data
}

const SfPostRequest = async (url, data) => {
  const response = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify(data.payload.payload),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: data?.token,
      "account-id": data?.account_id,
      "brand-id": data?.brand_id
    },
  })

  const responseText = await responseErrorChecker(response)
  // Handle success
  return JSON.parse(responseText).data
}

/**
 * Returns a query string for the parameters passes
 *
 * @param {Object}  query_params object with key = param, value = param_value
 */
const getQueryParamsFromObject = (query_params, skip_undefined = false) => {
  if (!query_params) {
    return ""
  }

  const query_string_arr = []
  for (const param in query_params) {
    if (skip_undefined && (query_params[param] === null || query_params[param] === undefined)) {
      continue;
    }
    const query_string = `${encodeURIComponent(param)}=${encodeURIComponent(query_params[param])}`
    query_string_arr.push(query_string)
  }
  return query_string_arr.join("&")
}

/**
 * @brief Wrapper for calling a GET request, application level handling the response.
 *
 * This function calls a GET request on @p url with @p headers headers.
 * The @p query_params array of objects is taken and each key value pair is URL encoded.
 * @param {string} url the url on which GET request is to be called
 * @param {Object}  query_params object with key = param, value = param_value
 * @param {Object} headers request headers object
 */
const fetchReport = async (url, query_params, headers) => {
  const res = await sf_fetch(`${url}`, {
    method: "GET",
    headers,
  })
  const blob = await res.blob()
  const file = window.URL.createObjectURL(
    new Blob([blob], { type: "application/pdf" })
  )
  window.open(file)
  return null
}

/**
 * @brief Wrapper for fetching the CSV exported data.
 *
 */
const fetchCSV = async (url, query_params, headers, filename) => {
  const query_string = getQueryParamsFromObject(query_params, true)
  const res = await sf_fetch(`${url}?${query_string}`, {
    method: "GET",
    headers,
  })
  const link = document.createElement('a');
  const blob = await res.blob()
  const file = window.URL.createObjectURL(
    new Blob([blob], { type: 'text/csv;charset=utf-8;' })
  )
  link.href = file
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  return null
}

/**
 * @brief Wrapper for fetching the CSV exported data.
 *
 */
const fetchCSVLeadDetail = async (url, query_params, headers, filename) => {
  const query_string = getQueryParamsFromObject(query_params, true)
  const res = await sf_fetch(`${url}?${query_string}`, {
    method: "GET",
    headers,
  })

  if (res.status !== 200) {
    return res
  }
  const link = document.createElement('a');
  const blob = await res.blob()
  const file = window.URL.createObjectURL(
    new Blob([blob], { type: 'text/csv;charset=utf-8;' })
  )
  link.href = file
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  return res
}

/**
 * @brief Wrapper for calling a GET request, application level handling the response.
 *
 * This function calls a GET request on @p url with @p headers headers.
 * The @p query_params array of objects is taken and each key value pair is URL encoded.
 * @param {string} url the url on which GET request is to be called
 * @param {Object}  query_params object with key = param, value = param_value
 * @param {Object} headers request headers object
 */
const genericGetRequest = async (url, query_params, headers) => {
  const query_string = getQueryParamsFromObject(query_params)
  const response = await sf_fetch(`${url}?${query_string}`, {
    method: "GET",
    headers,
  })

  const responseText = await responseErrorChecker(response)
  return JSON.parse(responseText).data
}

//Same as above but return additional info also(outside data)
const genericGetRequest_2 = async (url, query_params, headers, request_options = {}) => {
  const query_string = getQueryParamsFromObject(query_params, true)
  const response = await sf_fetch(`${url}?${query_string}`, {
    ...request_options,
    method: "GET",
    headers,
  })

  const responseText = await responseErrorChecker(response)
  return JSON.parse(responseText)
}

const genericGetRequestFeatures = async (url, query_params, headers) => {
  const query_string = getQueryParamsFromObject(query_params)
  const response = await sf_fetch(`${url}?${query_string}`, {
    method: "GET",
    headers,
  })

  const responseText = await responseErrorChecker(response)
  return JSON.parse(responseText).features
}

/**
 * @brief Wrapper for calling a PUT request, application level handling the response.
 *
 * This function calls a PUT request
 * The @p query_params array of objects is taken and each key value pair is URL encoded.
 * @param {string} url the url on which GET request is to be called
 * @param {Object} init request object passed to second parameter of fetch
 * @param {Object} query_params object with key = param, value = param_value
 */
const genericPutRequest = async (url, init, query_params) => {
  let query_string = ""
  for (const param in query_params) {
    query_string += `${encodeURIComponent(param)}=${encodeURIComponent(
      query_params[param]
    )}`
  }

  const response = await sf_fetch(`${url}?${query_string}`, {
    method: "PUT",
    ...init,
  })

  const responseText = await responseErrorChecker(response)
  return JSON.parse(responseText).data
}

/**
 * @brief Wrapper for calling a POST request, application level handling the response.
 *
 * This function calls a POST request
 *
 * @param {string} url the url on which GET request is to be called
 * @param {Object} init request object passed to second parameter of fetch
 * @returns
 */
const genericPostRequest = async (url, init) => {
  const response = await sf_fetch(url, {
    method: "POST",
    ...init,
  })

  const responseText = await responseErrorChecker(response)
  return JSON.parse(responseText).data
}

const genericPostRequestFeatures = async (url, init) => {
  const response = await sf_fetch(url, {
    method: "POST",
    ...init,
  })

  const responseText = await responseErrorChecker(response)
  return JSON.parse(responseText)
}

/**
 * @brief Wrapper for calling a DELETE request, application level handling the response.
 *
 * This function calls a DELETE request
 *
 * @param {string} url the url on which DELETE request is to be called
 * @param {Object} init request object passed to second parameter of fetch
 * @returns
 */
const genericDeleteRequest = async (url, init) => {
  const response = await sf_fetch(url, {
    method: "DELETE",
    ...init,
  })

  const responseText = await responseErrorChecker(response)
  try {
    return JSON.parse(responseText).data
  } catch (e) {
    return responseText;
  }
}

const genericDeleteRequestFeatures = async (url, init) => {
  const response = await sf_fetch(url, {
    method: "DELETE",
    ...init,
  })

  const responseText = await responseErrorChecker(response)
  return JSON.parse(responseText)
}

const putAgentProfileImages = async (url, data) => {
  const image = data.payload?.image
  const key = data.payload?.key
  const urlResponse = await sf_fetch(url, {
    method: "POST",
    body: JSON.stringify({ key: key }),
    headers: { ...data?.headers }
  })
  const urlResponseText = await responseErrorChecker(urlResponse)
  const preSignedUrl = JSON.parse(urlResponseText).data
  const s3Response = await sf_fetch(`${preSignedUrl.signed_url}`, {
    method: "PUT",
    body: image,
    headers: {
      'Content-Type': image.type,
      'Content-Disposition': `attachment; filename=${image.name}`,
    },
  })
  if (s3Response.ok) {
    const uploadData = _.omit(data.payload, ['image', 'key'])
    const response = await sf_fetch(`${AppConfiguration.BACKEND_URL}/api/v1/agent_profiles/${data?.payload?.id}`, {
      method: "PUT",
      body: JSON.stringify(uploadData),
      headers: { ...data.headers }
    })
    const responseText = await responseErrorChecker(response)
    return JSON.parse(responseText).data
  }
  else {
    throw "Sorry! file upload to S3 failed."
  }
}

export {
  getLoggedInUser,
  isUserAuthenticated,
  postJwtRegister,
  postJwtLogin,
  postJwtAdminLogin,
  postJwtForgetPwd,
  postJwtResetPwd,
  postJwtUpdatePwd,
  postCreateCampaign,
  deleteCampaign_api,
  postCreateAdgroup,
  putModifyCampaign,
  postCreateRole,
  putModifyRole,
  getRoles,
  getCampaigns,
  putModifyAdgroup,
  postDuplicateCampaign,
  fetchAds,
  postCreateAd,
  putModifyAd,
  getCurrentUser,
  fetchAccount,
  postDuplicateAd,
  deleteCampaign_Ad,
  deleteCreativeAd,
  genericGetRequest,
  genericGetRequest_2,
  genericPutRequest,
  genericPostRequest,
  genericDeleteRequest,
  postCreateAdgrouptracking,
  deleteAdgroup_api,
  postCreateConversions,
  getPresignedUrl,
  postFileToPresignedUrl,
  getBrands,
  createBrand,
  SfPostRequest,
  sfGenericRequest,
  fetchReport,
  fetchCSV,
  fetchCSVLeadDetail,
  genericGetRequestFeatures,
  genericPostRequestFeatures,
  genericDeleteRequestFeatures,
  postWithFileUploader,
  putAgentProfileImages
}
